import axios from "axios";
import {
  API_MAX_CONTENT_LENGTH,
  API_TIMEOUT_LIMIT,
} from "../../helpers/constants";

const baseURL = process.env.REACT_APP_ADMIN_CMS_API_URL;

const siteCoreApiInstance = axios.create({
  baseURL: baseURL,
  timeout: API_TIMEOUT_LIMIT,
  maxContentLength: API_MAX_CONTENT_LENGTH,
});

siteCoreApiInstance.interceptors.request.use(
  (request) => {
    request.headers["sc_apikey"] = process.env.REACT_APP_ADMIN_CMS_API_KEY;
    request.headers["Content-Type"] = "application/json";

    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

siteCoreApiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    //Need to handle in other way
    //return Promise.reject(error);
  },
);

export default siteCoreApiInstance;
